import React from 'react';
import Options from './Options';
import { sumConfig } from '../utils/utils';
import logo from './../assets/img/icons/logo.svg';
import logoWhite from './../assets/img/icons/logo-white.svg';


export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            burgerMenu: false,
        }
    }

    logoWhiteOrBlack() {
        return (this.props.currentStage === 2 && !this.props.modalPdf) && window.innerWidth > 1200
    }

    _openAndCloseBurgerMenu() {
        document.querySelector('body').style.overflow = this.state.burgerMenu ? "" : "hidden";

        this.setState(prevState => ({
            burgerMenu: !prevState.burgerMenu
        }))
    }
    
    render() {
        const config = this.props.config;
        const sum = sumConfig(config);

        return (
            <header className={`header ${this.logoWhiteOrBlack()  ? 'header--white' : ''} ${this.props.modalPdf ? 'header--pdf' : ''}`}>
                <div className='header__aside'>
                    <div className="header__logo">
                        <img src={this.logoWhiteOrBlack() ? logoWhite : logo} alt=""/>
                    </div>
                    <Options
                        renderConfig = {this.props.renderConfig}
                        setStatusWindow = {this.props.setStatusWindow} config={this.props.config}
                    ></Options>
                </div>

                {
                    window.innerWidth < 1200 && !this.props.modalPdf ?
                    <>
                        <div className={`header__burger ${this.state.burgerMenu ? 'header__burger--active' : ''}`} onClick={() => this._openAndCloseBurgerMenu()}>
                            <div className='header__burger-line'></div>
                        </div>
                        <div className={`header__mobile-menu ${this.state.burgerMenu ? 'header__mobile-menu--active' : ''}`}>
                            <ul className='header__links'>
                                <li className='header__link header__link--group'><a className='header__link-item' href={window.location.origin}>Главная</a></li>
                                <li className='header__link header__link--group'><a className='header__link-item' href={window.location.origin + '/proekty/'}>Изготовление мебели</a></li>
                                <li className='header__link'><a className='header__link-item' href={window.location.origin + '/shop/'}>Каталог</a></li>
                                <li className='header__link'><a className='header__link-item' href={window.location.origin + '/kompanija/'}>Компания</a></li>
                                <li className='header__link header__link--group'><a className='header__link-item' href={window.location.origin + '/dostavka/'}>Доставка</a></li>
                                <li className='header__link'><a className='header__link-item' href={window.location.origin + '/material/'}>Материал</a></li>
                                <li className='header__link'><a className='header__link-item' href={window.location.origin + "/dileram/"}>Дилерам</a></li>
                                <li className='header__link header__link--group'><a className='header__link-item' href={window.location.origin + "/kontakty/"}>Контакты</a></li>
                                <li className='header__link'><a className='header__link-item' href='tel:+74954871287'>+7 495 487 1287</a></li>
                            </ul>
                        </div>
                    </> 
                    
                    :
                    <>
                    <div className='options-menu' >
                        
                        <button onClick={() => {
                            this.props.setStatusWindow({
                                value: true,
                                type: 'form'
                            })
                        }} 
                        className="header__busket-button button"
                        >
                            <div className="button__content" >
                                <span>Итог: {sum} ₽</span>
                                <span>Оформление заказа</span>
                            </div>
                        </button>
                    </div>
                    </>
                }

                {
                    this.props.modalPdf ? 
                    <button className='header__pdf-close modal-window__close' onClick={() => this.props.modalPDFClose()}>
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L18 18M18 18L35 35M18 18L35 1M18 18L1 35" stroke="black" strokeWidth="2"/>
                        </svg>
                    </button> 
                    : 
                    ''
                }
            </header>
        )
    }
}
